import React from 'react';
import { DRNButton } from '@traveloka/district-ui';

import R from 'common/res/R';

const buttonStyle = {
  ...R.style.buttonText,
  containerStyle: {
    ...R.style.buttonText.containerStyle,
    minWidth: 75,
    paddingVertical: R.spacing.xs,
  },
};

const primaryButtonStyle = {
  ...buttonStyle,
  textColors: {
    active: R.color.brand,
    pressed: R.color.brand,
    disabled: R.color.uiLightSecondary,
  },
};

const negativeButtonStyle = {
  ...buttonStyle,
  textColors: R.style.buttonDestructiveSecondary.textColors,
};

const buttonType = {
  PRIMARY: 'PRIMARY',
  NEGATIVE: 'NEGATIVE',
};

const buttonStyleMap = {
  [buttonType.PRIMARY]: primaryButtonStyle,
  [buttonType.NEGATIVE]: negativeButtonStyle,
};

const PopupModalButton = ({ text, type = buttonType.PRIMARY, ...props }) => (
  <DRNButton text={text} buttonStyle={buttonStyleMap[type]} {...props} />
);

PopupModalButton.type = buttonType;

export default PopupModalButton;
